import React, { PropsWithChildren } from 'react';
import { WithBaseElementGlobalAttributes, WithIcon, WithOnClick } from '@/types/component';
import { cn } from '@/utils/shad';
import { Button } from '@/comps/primitives/button';
import { IconType } from '@/constants/icons';

type Props = WithBaseElementGlobalAttributes &
  PropsWithChildren &
  WithOnClick<React.MouseEvent<HTMLButtonElement>> &
  WithIcon & {
    appendIcon?: IconType;
    disabled?: boolean;
    disabledMessage?: string;
  };

export const UIPopoverMenuItem = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, onClick, icon, id, className, appendIcon, disabled, disabledMessage }, ref) => {
    return (
      <Button
        ref={ref}
        id={id}
        variant="ghost"
        className={cn(
          'flex w-full justify-start transition-colors hover:bg-accent hover:text-accent-foreground',
          className,
        )}
        onClick={onClick}
        PrependIcon={icon}
        AppendIcon={appendIcon}
        disabled={disabled}
        disabledMessage={disabledMessage}
      >
        <span className="min-w-0 flex-1 text-left">{children}</span>
      </Button>
    );
  },
);

UIPopoverMenuItem.displayName = 'UIPopoverMenuItem';
